import React from 'react'
import { useSelector } from 'react-redux'
import { ROUTES } from 'constants/routes'
import { APP_PRODUCT } from 'constants/app-config'
import { NetworkLogo } from 'gu-ui-kit'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import styles from 'layouts/AuthLayout/AuthLayout.module.scss'
import { IS_APP_PRODUCT_GETUNIQ } from 'utils/constants/product'
import { selectAppLocale } from 'modules/App/store/selectors'

export const Logo = () => {
  const i18n = useSelector(selectAppLocale)
  const pathGen = useGeneratePathI18n()

  return (
    <a href={i18n === 'ru' ? '/' : pathGen(ROUTES.MAIN)}>
      <NetworkLogo
        width={IS_APP_PRODUCT_GETUNIQ ? 93 : 101}
        height={32}
        name={APP_PRODUCT}
        color={'Label-Primary'}
        className={styles['layout__logo']}
      />
    </a>
  )
}
